function ensureArray(values) {
    if (!(values instanceof Array)) {
        values = [values];
    }

    return values;
}

export default ensureArray;
